import { storyblokEditable, useStoryblok } from "@storyblok/react";
import { getEnvironmentVersion } from "../../utils/getEnvironmentVersion";
import { LoadingComponent } from "../LoadingComponent";

export const FooterBuffer = () => {
  const footerBufferStory = useStoryblok("footer-buffer", {
    version: getEnvironmentVersion(),
  });

  return (
    <LoadingComponent
      loading={!footerBufferStory || !footerBufferStory.content}
    >
      <div {...storyblokEditable(footerBufferStory.content)}>
        <div className="demo-full">
          <div className="demo-copy">
            <h2>{footerBufferStory.content?.heading}</h2>
            <p>{footerBufferStory.content?.copy}</p>
          </div>
          <div className="demo-button">
            <a className="button button-footer-demo" href="/book-demo">
              {footerBufferStory.content?.buttonText}
            </a>
          </div>
        </div>
      </div>
    </LoadingComponent>
  );
};
